import {post} from "./http";
import qs from "qs";

export const toPost = <REQ, RSP>(url : string)=>{
    return async (data : REQ):Promise<RSP> => {
        return await post<RSP>(url, qs.stringify(data))
    }
};
